import {useSearchParams} from "react-router";
import {useEffect, useState} from "react";
import {updateUrlParams} from "../../utils";
import {FieldAutoComplete} from "./index";


export interface CustomerFilterAutoCompleteItem {
    label: string
    customerNumber: string
    id: string
}

interface CustomerFilterAutoCompleteProps {
    param: string
    items: CustomerFilterAutoCompleteItem[],
    search: (query: string) => Promise<CustomerFilterAutoCompleteItem[]>
}

function CustomerFilterAutoComplete({
                                        param,
                                        items,
                                        search
                                    }: CustomerFilterAutoCompleteProps) {
    const [searchParams, setSearchParams] = useSearchParams()
    const [value, setValue] = useState<CustomerFilterAutoCompleteItem | undefined>()
    const customerId = searchParams.get(param)

    useEffect(() => {
        setValue(items.find(e => e.id === customerId))
    }, [customerId, items])

    return <>
        <FieldAutoComplete
            label={"Kunde"}
            value={value}
            options={items}
            itemRenderer={c => c.label || c.id}
            search={v => search(v)}
            onChange={(v: CustomerFilterAutoCompleteItem | undefined) => {
                const customerId = v?.id
                updateUrlParams({
                    val: [{
                        param,
                        value: customerId ? [customerId] : undefined
                    }],
                    searchParams,
                    setSearchParams
                })
            }}
        />
    </>
}

export {
    CustomerFilterAutoComplete
}
